module.exports = __webpack_public_path__ + "static/media/cereales_pan.5a9e0218.png";